export const PRODUCT_CONFIG = {
  JUGS: {
    SKU: process.env.REACT_APP_JUG_SKU || 'JUG-20L',
    DISPLAY_NAME: 'Botellón 20L'
  },
  DISPENSERS: {
    SKU: process.env.REACT_APP_PORTDISPENSER_SKU || 'PORTDIS-SM',
    DISPLAY_NAME: 'Dispensador'
  }
}